export default {
    data: () => ({
        currentUser: '',
        environment: ''
    }),
    mounted: async function () {
        this.refreshEnvironment();
    },
    methods: {
        refreshEnvironment: function () {
            this.currentUser = localStorage.getItem('userName');
            this.environment = localStorage.getItem('environment');
        },
        isUnitTest: function () {
            return !document.location.href.includes('dashboard');
        },
        isRunningLocally: function () {
            return location.href.includes('localhost');
        }
    }
};
